import { PriceList,ProductRequest } from "@/types/ProductTypes";
import config from '@/settings/config.js';
import _axios from './axios';

class ProductService
{
    async fetchPortifolioProducts(product: ProductRequest) : Promise<PriceList>
    {
       const prdt= await  _axios.get<PriceList>(`${config.gateway}payment/ProductPrice/QueryProduct/
       ${product.portiFolio}/${product.isoCountry}/${product.location}?page=${product.page}`);
       return prdt.data;
    }

    async fetchPortifolioOnlyProducts(portiFolio: string, originator: string, parameters: string|null) : Promise<PriceList>
    {
       let dto ={
          portiFolio,
          originator,
          parameters
       }
       const prdt= await  _axios.post<PriceList>(`${config.gateway}payment/ProductPrice/V2/QueryProduct`,
        dto);
       return prdt.data;
    }
}

export default new ProductService();